import {
  INIT_URL,
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  SET_AUTH_DATA,
  SET_AUTH_USER,
  SIGNIN_USER,
  SIGNIN_USER_ERROR,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  UNAUTHORIZED,
} from 'constants/ActionTypes';

// Handles submitting of auth form
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    user,
  };
};

// Handles submitting of auth form
export const resetPassword = (email) => {
  return {
    type: RESET_PASSWORD,
    email,
  };
};

// Handles success reset password
export const resetPasswordSuccess = (email) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    email,
  };
};

// Handles error in reset password
export const resetPasswordError = (errors) => {
  return {
    type: RESET_PASSWORD_ERROR,
    errors,
  };
};

// Handles success auth of user
export const userSignInSuccess = (data) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    data,
  };
};

// Handles error in user auth
export const userSignInError = (errors) => {
  return {
    type: SIGNIN_USER_ERROR,
    errors,
  };
};

// Handles user sing out
export const userSignOut = () => {
  return {
    type: SIGNOUT_USER,
  };
};

// Handles success user sign out
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  };
};

// Handles setting of auth user on application startup
export const setAuthUser = (user) => {
  const { companyAlias: alias } = user;
  return {
    type: SET_AUTH_USER,
    user,
    alias,
  };
};

// Clear store and background saga effects after 401 response
export const unauthorized = () => {
  return {
    type: UNAUTHORIZED,
  };
};

// Handles setting of the auth token
export const setAuthData = (data) => {
  return {
    type: SET_AUTH_DATA,
    data,
  };
};

// Save initial app url for redirecting after auth
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    url,
  };
};
